import {
  SHOW_DECLARATION_DESERTED_QUOTE_DIALOG,
  CLOSE_DECLARATION_DESERTED_QUOTE_DIALOG
} from './QuoteDeclarationDesertedDialog.actions'

const declarationDesertedyQuoteDialogState = {
  error: false,
  loading: false,
  open: false,
  showDeclarationInadmissibility: false,
  justificationsCriteria: [],
  quoteBid: null
}

/**
 * The declarationInadmissibilityQuoteDialog's reducer.
 */
const declarationDesertedyQuoteDialogReducer = (state = declarationDesertedyQuoteDialogState, { type }) => {
  switch (type) {
    case SHOW_DECLARATION_DESERTED_QUOTE_DIALOG: {
      return {
        ...state,
        open: true
      }
    }
    case CLOSE_DECLARATION_DESERTED_QUOTE_DIALOG: {
      return {
        ...state,
        open: false
      }
    }
    default: {
      return state
    }
  }
}

export default declarationDesertedyQuoteDialogReducer
